import type { TradingEvent } from '@/services/tradingEventsApi';

export function formatTradingEventTime(tsMs: number): string {
  return new Date(tsMs).toLocaleTimeString(undefined, {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });
}

export function tradingEventCategoryLabel(category: TradingEvent['category']): string {
  switch (category) {
    case 'instruction':
      return '指令';
    case 'order':
      return '订单';
    case 'task':
      return '任务';
    default:
      return '系统';
  }
}

export function formatTradingEventFillNumber(value: number, digits = 4): string {
  if (!Number.isFinite(value)) return '—';
  const abs = Math.abs(value);
  const maxDigits = abs >= 1000 ? 2 : abs >= 1 ? digits : 6;
  return value.toLocaleString(undefined, {
    maximumFractionDigits: maxDigits,
    minimumFractionDigits: 0,
  });
}

export function tradingEventOrderFillMetrics(
  event: TradingEvent,
): { tokenSize: number; notionalUsd: number } | null {
  if (event.category !== 'order' || event.action !== 'filled') return null;
  const data = event.data;
  if (!data) return null;
  const tokenSize = Number(data.token_size);
  const notionalUsd = Number(data.notional_usd);
  if (!(tokenSize > 0) && !(notionalUsd > 0)) return null;
  return {
    tokenSize: Number.isFinite(tokenSize) ? tokenSize : 0,
    notionalUsd: Number.isFinite(notionalUsd) ? notionalUsd : 0,
  };
}

export function formatTradingEventLine(event: TradingEvent): string {
  const fillMetrics = tradingEventOrderFillMetrics(event);
  const parts = [`[${tradingEventCategoryLabel(event.category)}] ${event.title}`, event.message];
  if (fillMetrics) {
    parts.push(
      `Token ${formatTradingEventFillNumber(fillMetrics.tokenSize)} · USD ${formatTradingEventFillNumber(fillMetrics.notionalUsd, 2)}`,
    );
  }
  return parts.filter(Boolean).join(' — ');
}
